import script from "./EnemyShip.vue?vue&type=script&lang=js"
export * from "./EnemyShip.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__